export const translations = {
  en: {
    nav: {
      services: "Services",
      why: "Why Us",
      projects: "Projects",
      reviews: "Reviews",
      contact: "Contact",
      cta: "Get Free Quote",
    },
    hero: {
      eyebrow: "Outdoor Structure Specialists",
      title: "Trusted Outdoor Structure Installation Specialists",
      subtitle:
        "Xavier Assembly installs gazebos, pergolas and outdoor structures. Request from any of the 50 states: verified models get an automatic quote by email; other models, including PERGOLUX and BON PERGOLA, are reviewed by our team. Our team confirms availability by ZIP and Xavier confirms your installation date.",
      cta1: "Get Free Quote",
      cta2: "View Projects",
      badges: [
        "Model-specific quotes",
        "Availability confirmed by our team",
        "Quote Requests Across the U.S.",
        "English • Portuguese • Spanish",
      ],
    },
    awards: {
      eyebrow: "Trusted by the Community",
      title: "Vacaville chose us 3 years in a row",
      subtitle:
        "Proudly recognized as a Nextdoor Neighborhood Fave in 2023, 2024, and 2025 for professionalism, quality workmanship, and trusted service.",
      yearLabel: "Neighborhood Fave",
      cta: "Thank you to our community for trusting Xavier Assembly year after year.",
      placeholder: "Upload award image",
    },
    services: {
      eyebrow: "What We Install",
      quote_coverage: "Nationwide Quote Requests",
      quote_availability: "Quote requests are welcome from all 50 U.S. states and Washington, DC. Enter your ZIP and confirm the state; our team confirms local installation availability.",
      location_pages: "Existing Location Pages",
      title: "Premium Installation Services",
      subtitle:
        "From Costco gazebos to Yardistry pergolas, we handle every outdoor structure with precision and care.",
      items: [
        { title: "Gazebo Installation", desc: "Costco, Yardistry & custom gazebos assembled to factory spec." },
        { title: "Pergola Installation", desc: "Wood, aluminum and modern louvered pergolas built to last." },
        { title: "Shed Assembly", desc: "Storage, garden and workshop sheds — leveled and weather-sealed." },
        { title: "Sauna Installation", desc: "Outdoor barrel and cabin saunas wired and finished correctly." },
        { title: "Playground Assembly", desc: "Safe, code-compliant playsets installed for backyards & HOAs." },
        { title: "Gym Equipment Installation", desc: "Home gyms, racks, cable machines and outdoor fitness setups." },
      ],
    },
    why: {
      eyebrow: "Why Choose Us",
      title: "Built On Craft. Backed By Trust.",
      subtitle: "We don't just assemble — we install with the discipline of a contractor and the eye of a craftsman.",
      items: [
        { title: "Professionalism", desc: "Crew availability, scope and required documentation are reviewed for each job." },
        { title: "Precision", desc: "Laser-leveled foundations, torque-spec hardware, factory-grade results." },
        { title: "Safety", desc: "OSHA-aware installs, anchored structures, code-compliant playsets." },
        { title: "Clean Finish", desc: "Assembly work area left tidy. Packaging, trash and pallet removal are included only when quoted and agreed." },
        { title: "Reliable Communication", desc: "Real-time updates from quote to final walkthrough." },
        { title: "Experienced Team", desc: "We review your model, installation site and requested scope before confirming the work." },
      ],
    },
    projects: {
      eyebrow: "Featured Projects",
      title: "Selected Installations",
      subtitle: "A glimpse at recent gazebos, pergolas, saunas, gym setups and playgrounds delivered across California & Reno.",
    },
    reviews: {
      eyebrow: "Customer Reviews",
      title: "Customer feedback",
      items: [
        { name: "Sarah M.", role: "Walnut Creek, CA", text: "Outstanding job assembling my Costco gazebo. Level, square, and rock solid." },
        { name: "David R.", role: "Reno, NV", text: "Professional, punctual, and detail-oriented. Best contractor experience I've had." },
        { name: "Marcia L.", role: "San Jose, CA", text: "Highly recommend Xavier for outdoor projects. Pergola looks better than the showroom photo." },
        { name: "James K.", role: "Sacramento, CA", text: "They installed our outdoor sauna and home gym in two days. Flawless work." },
        { name: "Patricia O.", role: "Oakland, CA", text: "Great communication start to finish. Cleaned up everything. Worth every dollar." },
        { name: "Carlos T.", role: "Fremont, CA", text: "Falaram português comigo e instalaram um playground enorme com perfeição." },
      ],
    },
    googleReviews: {
      eyebrow: "Google Reviews",
      empty_heading: "Customer reviews",
      empty_status: "No customer reviews are published here yet.",
      empty_help: "For customer references, use the contact details in the footer.",
      loading: "Loading customer reviews…",
      unavailable: "Customer reviews are temporarily unavailable.",
      previous: "Previous review",
      next: "Next review",
      go_to_review: "Go to review",
      heading: "Real Customers. Real Projects. Real Reviews.",
      read_more: "Read More Reviews on Google",
      view_on_google: "View on Google",
      verified: "Verified",
    },
    cta: {
      eyebrow: "Free Estimates",
      title: "Ready to transform your outdoor space?",
      subtitle: "Free quote requests across the U.S. Our team confirms local availability and project requirements before scheduling.",
      call: "Call Now",
      quote: "Request Quote",
    },
    form: {
      title: "Request Your Free Quote",
      subtitle: "Tell us about your project. We'll respond within 24 hours.",
      name: "Full name",
      email: "Email address",
      phone: "Phone number",
      service: "Service needed",
      location: "City / Zip",
      message: "Project details",
      submit: "Send Request",
      submitting: "Sending...",
      success: "Quote request received.",
      error: "Something went wrong. Please call (510) 507-9318.",
      services_options: [
        "Gazebo Installation",
        "Pergola Installation",
        "Shed Assembly",
        "Sauna Installation",
        "Playground Assembly",
        "Gym Equipment Installation",
        "Other",
      ],
      // ── Multi-step form (8 steps) ──
      step_label_product: "Product",
      step_label_configure: "Configure",
      step_label_site: "Site",
      step_label_accessories: "Add-Ons",
      step_label_schedule: "Schedule",
      step_label_qualification: "Details",
      step_label_agreement: "Agreement",
      step_label_contact: "Contact",
      step_indicator: "Step {n} / {total}",
      response_promise: "We respond in under 24 hours",
      done: "Done",
      back: "Back",
      continue: "Continue",
      submit_request: "Send Request",
      // ── Step: Product ──
      what_installing: "What are we installing?",
      brand_model: "Brand / model",
      brand_model_ph: "e.g. Yardistry Meridian",
      structure_brand: "Structure brand (if different)",
      structure_brand_ph: "e.g. Sunjoy, Backyard Discovery…",
      purchased_from: "Purchased from",
      purchased_from_ph: "Where did you buy it?",
      size: "Size",
      size_ph: "Choose size",
      size_custom_ph: "Enter size (e.g. 15×22)",
      product_links: "Product links (optional)",
      product_links_ph: "Paste Costco, Amazon, Yardistry link…",
      link_invalid: "Link must start with http:// or https://",
      photos: "Photos (optional)",
      drop_or_click: "Drop or click to upload",
      photo_hint: "JPG / PNG / WEBP · 6 per section · 1MB each · 6MB total across all sections",
      photo_total_too_large: "Photos can total up to 6MB across all sections. Remove a photo or choose a smaller image.",
      photo_too_many: "Upload up to 6 photos per section.",
      photo_too_large: "{name} is larger than 1MB. Choose a smaller image.",
      photo_invalid: "{name}: use a JPG, PNG or WEBP image.",
      photo_read_error: "Could not read {name}. Please try another image.",
      // ── Step: Configure ──
      configure_intro: "Help us spec your {category} exactly right. The more we know, the more accurate your quote.",
      structure_material: "Structure material",
      roof_type: "Roof type",
      shed_material: "Shed material",
      foundation_type: "Foundation type",
      platform_option: "Platform option",
      // ── Step: Site ──
      install_location: "Install location",
      install_location_ph: "Where?",
      ground_type: "Ground type",
      ground_type_ph: "Surface",
      target_install_date: "Target install date",
      city_zip: "City",
      city_zip_ph: "San Jose",
      state_label: "State",
      state_placeholder: "Select state",
      surface_type: "Surface type",
      product_delivered_q: "Has the product already been delivered on site?",
      existing_surface: "Existing surface at install spot (optional)",
      backyard_access: "Backyard access",
      assembly_complexity: "Assembly complexity",
      site_work_optional: "Additional site work needed (optional)",
      build_platform: "Build platform / foundation",
      teardown_old: "Teardown / remove old structure",
      relocate_existing: "Relocate existing gazebo / shed",
      electrical_access: "Electrical access available on site",
      backyard_photos: "Backyard photos (recommended)",
      backyard_photos_hint: "Photos of your install area help us prep tools, anchoring, and crew size.",
      inspiration_photos: "Inspiration / reference photos (optional)",
      inspiration_photos_hint: "Pinterest, Instagram, or any reference of the look you want.",
      // ── Step: Accessories (required Y/N gates) ──
      addons_intro: "Please answer each question. All Yes/No questions are required.",
      estimate_label: "Estimated add-ons",
      estimate_note: "Base install quoted after review",
      yes: "YES",
      no: "NO",
      blinds_q: "Does your item include blinds?",
      blinds_count_q: "How many blinds?",
      anchoring_q: "Do you need anchoring?",
      anchoring_count_q: "How many anchors?",
      anchoring_4_label: "4 anchors",
      anchoring_6_label: "6 anchors",
      led_q: "Does your item include LED lights?",
      pallet_q: "Do you need pallet removal?",
      pallet_count_q: "How many pallets? ($45 each)",
      estimated_cost: "Estimated cost:",
      optional_addons: "Optional installation add-ons",
      optional_addons_hint: "Select any that apply (optional).",
      addon_cardboard: "Box Breakdown Only (Left On-site)",
      addon_disposal: "Box Breakdown + Removal",
      optional_addons_bundle_note: "Choose one option. The $120 service includes box breakdown and removal, with no additional $45 charge. The $45 option is breakdown only; boxes stay on-site.",
      // ── Step: Schedule ──
      schedule_intro: "Pick your preferred installation date and time window. Final scheduling will be confirmed in your written quote.",
      preferred_date: "Preferred installation date",
      time_window: "Preferred time window",
      time_morning: "Morning",
      time_morning_desc: "8 AM – 12 PM",
      time_afternoon: "Afternoon",
      time_afternoon_desc: "12 PM – 4 PM",
      time_evening: "Evening",
      time_evening_desc: "4 PM – 7 PM",
      time_flexible: "Flexible",
      time_flexible_desc: "Any time of day",
      // ── Step: Qualification ──
      qual_intro: "A few quick questions to help us pre-qualify your project.",
      delivery_status: "Delivery status of your product",
      delivery_delivered: "Delivered",
      delivery_delivered_desc: "It's already at my property",
      delivery_scheduled: "Scheduled delivery",
      delivery_scheduled_desc: "I know when it arrives",
      delivery_not_yet: "Not delivered yet",
      delivery_not_yet_desc: "Still ordering / shipping",
      estimated_delivery_date: "Estimated delivery date",
      boxes_received: "How many boxes / pallets received?",
      boxes_received_ph: "Choose",
      hoa_q: "HOA approval required?",
      hoa_no: "No HOA / not required",
      hoa_no_desc: "We can schedule any time",
      hoa_yes: "Yes — HOA approval needed",
      hoa_yes_desc: "We'll wait for approval",
      hoa_unknown: "Not sure",
      hoa_unknown_desc: "We'll guide you",
      has_manual: "I have the installation manual",
      special_instructions: "Special instructions (optional)",
      special_instructions_ph: "Gate code, dogs, fragile plants, preferred crew time, etc.",
      // ── Step: Agreement ──
      agreement_intro: "Please review and accept all site conditions. Each acknowledgment is required to submit your booking.",
      ack_15ft_label: "Product boxes within 15 ft of install area",
      ack_15ft_text: "I understand the product boxes must be located within 15 feet of the final installation area. If boxes, pallets, or materials are farther than 15 ft, an additional material handling fee of $80 may apply.",
      ack_clear_access_label: "Path and install area will be clear",
      ack_clear_access_text: "I confirm the installation path and area will be clear and accessible before the crew arrives — free of furniture, storage, vehicles, construction or landscaping materials, debris, or any other obstacles.",
      ack_site_prep_label: "Site prep fee may apply ($80)",
      ack_site_prep_text: "I understand that if the crew is required to move furniture, materials, boxes, equipment, landscaping items, or other obstacles before installation can begin, an additional site preparation fee of $80 may apply.",
      ack_access_conditions_label: "Access conditions",
      ack_access_conditions_text: "I understand installation pricing assumes normal access. Additional charges may apply for stairs, steep hills, long carrying distances, restricted access, difficult terrain, or unusual site conditions.",
      ack_price_protection_label: "Final price may be adjusted",
      ack_price_protection_text: "I understand that final pricing may be adjusted if actual job-site conditions, product specifications, quantities, accessories, or installation requirements differ from the information provided during booking.",
      price_protection_notice: "Final pricing may be adjusted if actual job-site conditions or installation requirements differ from the information provided during booking.",
      price_protection_label: "Price Protection:",
      // ── Step: Contact (uses name/email/phone/location/message already above) ──
      contact_intro: "Almost done. Where do we reach you?",
      full_name_required: "Full name *",
      phone_required: "Phone *",
      email_required: "Email *",
      name_ph: "Jane Doe",
      phone_ph: "(510) 555-1234",
      email_ph: "you@example.com",
      additional_notes: "Additional notes (optional)",
      additional_notes_ph: "Anything else we should know?",
      consent_text: "By submitting, you agree to be contacted about your project. We respond within 24 hours.",
      // ── Success ──
      success_desc: "Your request is saved for review. Our team will contact you about the next steps.",
      confirmation_email_accepted: "Your confirmation email was accepted for sending. Inbox delivery has not been confirmed.",
      confirmation_email_unconfirmed: "Confirmation email submission could not be confirmed. Your request is still saved.",
      close: "Close",
      success_back_home: "Back to homepage",
      // ── Validation generic ──
      validation_error: "Validation error — check your inputs.",
    },
    footer: {
      tagline: "Accepting quote requests across the U.S. Local availability confirmed by our team.",
      quote_area: "Quote requests across the U.S.",
      contact: "Contact",
      languages: "Languages",
      hours: "Mon – Sat: 8am – 7pm",
      rights: "All rights reserved.",
      keywords: "Gazebo Installer · Pergola Installer · Costco Gazebo Installer · Yardistry Installer · Outdoor Structure Specialist",
    },
  },
  pt: {
    nav: {
      services: "Serviços",
      why: "Por Que Nós",
      projects: "Projetos",
      reviews: "Avaliações",
      contact: "Contato",
      cta: "Orçamento Grátis",
    },
    hero: {
      eyebrow: "Especialistas em Estruturas Externas",
      title: "Especialistas em Instalação de Estruturas Externas",
      subtitle:
        "A Xavier Assembly instala gazebos, pergolados e estruturas externas. Peça de qualquer um dos 50 estados: modelos verificados recebem orçamento automático por e-mail; outros modelos, incluindo PERGOLUX e BON PERGOLA, são analisados pela nossa equipe. Nossa equipe confirma a disponibilidade pelo ZIP e a Xavier confirma a data da instalação.",
      cta1: "Orçamento Grátis",
      cta2: "Ver Projetos",
      badges: [
        "Orçamento para seu modelo",
        "Disponibilidade confirmada pela equipe",
        "Pedidos de Orçamento em Todos os EUA",
        "Inglês • Português • Espanhol",
      ],
    },
    awards: {
      eyebrow: "Reconhecido pela Comunidade",
      title: "Vacaville nos escolheu 3 anos seguidos",
      subtitle:
        "Reconhecidos com orgulho como Nextdoor Neighborhood Fave em 2023, 2024 e 2025 por profissionalismo, qualidade no trabalho e serviço de confiança.",
      yearLabel: "Neighborhood Fave",
      cta: "Obrigado à nossa comunidade por confiar na Xavier Assembly ano após ano.",
      placeholder: "Envie a imagem do prêmio",
    },
    services: {
      eyebrow: "O Que Instalamos",
      quote_coverage: "Pedidos de Orçamento em Todos os EUA",
      quote_availability: "Recebemos pedidos de orçamento dos 50 estados dos EUA e de Washington, DC. Informe seu ZIP e confirme o estado; nossa equipe confirma a disponibilidade de instalação na sua região.",
      location_pages: "Páginas de Localidades",
      title: "Serviços Premium de Instalação",
      subtitle:
        "De gazebos Costco a pérgolas Yardistry, cuidamos de cada estrutura com precisão.",
      items: [
        { title: "Instalação de Gazebo", desc: "Gazebos Costco, Yardistry e personalizados montados conforme fábrica." },
        { title: "Instalação de Pérgola", desc: "Pérgolas em madeira, alumínio e modelos modernos com lâminas." },
        { title: "Montagem de Galpão", desc: "Galpões de armazenamento, jardim e oficina nivelados e selados." },
        { title: "Instalação de Sauna", desc: "Saunas barril e cabine externas com acabamento completo." },
        { title: "Montagem de Playground", desc: "Playsets seguros e conformes para quintais e condomínios." },
        { title: "Equipamentos de Academia", desc: "Academias em casa, racks, máquinas e equipamentos externos." },
      ],
    },
    why: {
      eyebrow: "Por Que Nos Escolher",
      title: "Construído Com Ofício. Sustentado Pela Confiança.",
      subtitle: "Não apenas montamos — instalamos com a disciplina de um construtor e o olho de um artesão.",
      items: [
        { title: "Profissionalismo", desc: "Disponibilidade da equipe, escopo e documentação necessária são analisados para cada serviço." },
        { title: "Precisão", desc: "Fundações niveladas a laser e parafusos com torque de fábrica." },
        { title: "Segurança", desc: "Instalações conforme OSHA, estruturas ancoradas, playsets em norma." },
        { title: "Acabamento Limpo", desc: "Área de montagem organizada ao final. Retirada de embalagens, lixo e paletes somente quando incluída no orçamento e acordada." },
        { title: "Comunicação Confiável", desc: "Atualizações em tempo real do orçamento à entrega final." },
        { title: "Equipe Experiente", desc: "Analisamos seu modelo, local de instalação e escopo solicitado antes de confirmar o serviço." },
      ],
    },
    projects: {
      eyebrow: "Projetos em Destaque",
      title: "Instalações Selecionadas",
      subtitle: "Veja gazebos, pérgolas, saunas, academias e playgrounds entregues recentemente.",
    },
    reviews: {
      eyebrow: "Avaliações de Clientes",
      title: "Opiniões de clientes",
      items: [
        { name: "Sarah M.", role: "Walnut Creek, CA", text: "Trabalho excelente montando meu gazebo da Costco. Nivelado e firme." },
        { name: "David R.", role: "Reno, NV", text: "Profissional, pontual e detalhista. Melhor experiência com contratado." },
        { name: "Marcia L.", role: "San Jose, CA", text: "Recomendo muito o Xavier para projetos externos. Pérgola perfeita." },
        { name: "James K.", role: "Sacramento, CA", text: "Instalaram sauna e academia em dois dias. Trabalho impecável." },
        { name: "Patricia O.", role: "Oakland, CA", text: "Ótima comunicação do início ao fim. Vale cada dólar." },
        { name: "Carlos T.", role: "Fremont, CA", text: "Atendimento em português e playground enorme instalado com perfeição." },
      ],
    },
    googleReviews: {
      eyebrow: "Avaliações do Google",
      empty_heading: "Avaliações de clientes",
      empty_status: "Ainda não há avaliações de clientes publicadas aqui.",
      empty_help: "Para informações sobre referências de clientes, use os contatos no rodapé.",
      loading: "Carregando avaliações de clientes…",
      unavailable: "As avaliações de clientes estão temporariamente indisponíveis.",
      previous: "Avaliação anterior",
      next: "Próxima avaliação",
      go_to_review: "Ir para a avaliação",
      heading: "Clientes Reais. Projetos Reais. Avaliações Reais.",
      read_more: "Ver mais avaliações no Google",
      view_on_google: "Ver no Google",
      verified: "Verificado",
    },
    cta: {
      eyebrow: "Orçamentos Grátis",
      title: "Pronto para transformar seu espaço externo?",
      subtitle: "Pedidos de orçamento grátis em todos os EUA. Nossa equipe confirma a disponibilidade local e os requisitos do projeto antes do agendamento.",
      call: "Ligar Agora",
      quote: "Pedir Orçamento",
    },
    form: {
      title: "Solicite Seu Orçamento Grátis",
      subtitle: "Conte sobre seu projeto. Respondemos em até 24 horas.",
      name: "Nome completo",
      email: "Endereço de email",
      phone: "Telefone",
      service: "Serviço desejado",
      location: "Cidade / CEP",
      message: "Detalhes do projeto",
      submit: "Enviar Pedido",
      submitting: "Enviando...",
      success: "Pedido de orçamento recebido.",
      error: "Algo deu errado. Ligue para (510) 507-9318.",
      services_options: [
        "Instalação de Gazebo",
        "Instalação de Pérgola",
        "Montagem de Galpão",
        "Instalação de Sauna",
        "Montagem de Playground",
        "Equipamentos de Academia",
        "Outro",
      ],
      // ── Etapas (8 passos) ──
      step_label_product: "Produto",
      step_label_configure: "Configuração",
      step_label_site: "Local",
      step_label_accessories: "Acessórios",
      step_label_schedule: "Agendamento",
      step_label_qualification: "Detalhes",
      step_label_agreement: "Termos",
      step_label_contact: "Contato",
      step_indicator: "Etapa {n} / {total}",
      response_promise: "Respondemos em até 24 horas",
      done: "Pronto",
      back: "Voltar",
      continue: "Continuar",
      submit_request: "Enviar Pedido",
      // ── Produto ──
      what_installing: "O que vamos instalar?",
      brand_model: "Marca / modelo",
      brand_model_ph: "ex: Yardistry Meridian",
      structure_brand: "Marca da estrutura (se diferente)",
      structure_brand_ph: "ex: Sunjoy, Backyard Discovery…",
      purchased_from: "Comprado em",
      purchased_from_ph: "Onde você comprou?",
      size: "Tamanho",
      size_ph: "Escolha o tamanho",
      size_custom_ph: "Digite o tamanho (ex: 15×22)",
      product_links: "Links do produto (opcional)",
      product_links_ph: "Cole link da Costco, Amazon, Yardistry…",
      link_invalid: "O link deve começar com http:// ou https://",
      photos: "Fotos (opcional)",
      drop_or_click: "Arraste ou clique para enviar",
      photo_hint: "JPG / PNG / WEBP · 6 por seção · 1MB cada · 6MB no total entre todas as seções",
      photo_total_too_large: "As fotos podem somar até 6MB entre todas as seções. Remova uma foto ou escolha uma imagem menor.",
      photo_too_many: "Envie até 6 fotos por seção.",
      photo_too_large: "{name} é maior que 1MB. Escolha uma imagem menor.",
      photo_invalid: "{name}: use uma imagem JPG, PNG ou WEBP.",
      photo_read_error: "Não foi possível ler {name}. Tente outra imagem.",
      // ── Configuração ──
      configure_intro: "Vamos especificar seu {category} com precisão. Quanto mais soubermos, mais exato será seu orçamento.",
      structure_material: "Material da estrutura",
      roof_type: "Tipo de telhado",
      shed_material: "Material do galpão",
      foundation_type: "Tipo de fundação",
      platform_option: "Opção de plataforma",
      // ── Local ──
      install_location: "Local de instalação",
      install_location_ph: "Onde?",
      ground_type: "Tipo de solo",
      ground_type_ph: "Superfície",
      target_install_date: "Data desejada de instalação",
      city_zip: "Cidade",
      city_zip_ph: "San Jose",
      state_label: "Estado",
      state_placeholder: "Selecione o estado",
      surface_type: "Tipo de superfície",
      product_delivered_q: "O produto já foi entregue no local?",
      existing_surface: "Superfície existente no local (opcional)",
      backyard_access: "Acesso ao quintal",
      assembly_complexity: "Complexidade da montagem",
      site_work_optional: "Serviços adicionais no local (opcional)",
      build_platform: "Construir plataforma / fundação",
      teardown_old: "Desmontar / remover estrutura antiga",
      relocate_existing: "Realocar gazebo / galpão existente",
      electrical_access: "Acesso elétrico disponível no local",
      backyard_photos: "Fotos do quintal (recomendado)",
      backyard_photos_hint: "Fotos da área de instalação nos ajudam a preparar ferramentas, ancoragem e equipe.",
      inspiration_photos: "Fotos de inspiração / referência (opcional)",
      inspiration_photos_hint: "Pinterest, Instagram ou qualquer referência do visual desejado.",
      // ── Acessórios (gates obrigatórios) ──
      addons_intro: "Responda cada pergunta. Todas as perguntas Sim/Não são obrigatórias.",
      estimate_label: "Adicionais estimados",
      estimate_note: "Instalação base cotada após revisão",
      yes: "SIM",
      no: "NÃO",
      blinds_q: "Seu item inclui cortinas?",
      blinds_count_q: "Quantas cortinas?",
      anchoring_q: "Você precisa de ancoragem?",
      anchoring_count_q: "Quantas âncoras?",
      anchoring_4_label: "4 âncoras",
      anchoring_6_label: "6 âncoras",
      led_q: "Seu item inclui luzes LED?",
      pallet_q: "Você precisa de remoção de palete?",
      pallet_count_q: "Quantos paletes? ($45 cada)",
      estimated_cost: "Custo estimado:",
      optional_addons: "Adicionais opcionais de instalação",
      optional_addons_hint: "Selecione os que se aplicam (opcional).",
      addon_cardboard: "Somente Desmontagem de Caixas (Ficam no Local)",
      addon_disposal: "Desmontagem + Retirada de Caixas",
      optional_addons_bundle_note: "Escolha uma opção. O serviço de US$120 inclui desmontagem e retirada das caixas, sem cobrança adicional de US$45. A opção de US$45 inclui somente a desmontagem; as caixas ficam no local.",
      // ── Agendamento ──
      schedule_intro: "Escolha sua data e janela de horário preferida. O agendamento final será confirmado no seu orçamento por escrito.",
      preferred_date: "Data preferida de instalação",
      time_window: "Janela de horário preferida",
      time_morning: "Manhã",
      time_morning_desc: "8h – 12h",
      time_afternoon: "Tarde",
      time_afternoon_desc: "12h – 16h",
      time_evening: "Noite",
      time_evening_desc: "16h – 19h",
      time_flexible: "Flexível",
      time_flexible_desc: "Qualquer hora do dia",
      // ── Detalhes ──
      qual_intro: "Algumas perguntas rápidas para pré-qualificar seu projeto.",
      delivery_status: "Status de entrega do seu produto",
      delivery_delivered: "Entregue",
      delivery_delivered_desc: "Já está na minha propriedade",
      delivery_scheduled: "Entrega agendada",
      delivery_scheduled_desc: "Sei quando chega",
      delivery_not_yet: "Ainda não entregue",
      delivery_not_yet_desc: "Ainda comprando / enviando",
      estimated_delivery_date: "Data estimada de entrega",
      boxes_received: "Quantas caixas / paletes recebeu?",
      boxes_received_ph: "Escolha",
      hoa_q: "Aprovação do HOA necessária?",
      hoa_no: "Sem HOA / não obrigatório",
      hoa_no_desc: "Podemos agendar a qualquer momento",
      hoa_yes: "Sim — aprovação do HOA necessária",
      hoa_yes_desc: "Aguardaremos a aprovação",
      hoa_unknown: "Não tenho certeza",
      hoa_unknown_desc: "Nós o orientaremos",
      has_manual: "Tenho o manual de instalação",
      special_instructions: "Instruções especiais (opcional)",
      special_instructions_ph: "Senha do portão, cachorros, plantas frágeis, horário preferido da equipe, etc.",
      // ── Termos ──
      agreement_intro: "Revise e aceite todas as condições do local. Cada confirmação é obrigatória para enviar seu pedido.",
      ack_15ft_label: "Caixas do produto a até 4,5m (15 ft) da área de instalação",
      ack_15ft_text: "Entendo que as caixas do produto devem estar localizadas a até 4,5m (15 pés) da área final de instalação. Se as caixas, paletes ou materiais estiverem a mais de 4,5m, uma taxa adicional de manuseio de $80 poderá ser aplicada.",
      ack_clear_access_label: "Caminho e área de instalação estarão livres",
      ack_clear_access_text: "Confirmo que o caminho e a área de instalação estarão livres e acessíveis antes da chegada da equipe — sem móveis, armazenamento, veículos, materiais de construção ou paisagismo, entulho, ou qualquer outro obstáculo.",
      ack_site_prep_label: "Taxa de preparação do local pode ser aplicada ($80)",
      ack_site_prep_text: "Entendo que se a equipe precisar mover móveis, materiais, caixas, equipamentos, itens de paisagismo ou outros obstáculos antes do início da instalação, uma taxa adicional de preparação do local de $80 poderá ser aplicada.",
      ack_access_conditions_label: "Condições de acesso",
      ack_access_conditions_text: "Entendo que o preço da instalação assume acesso normal. Taxas adicionais podem ser aplicadas para escadas, ladeiras íngremes, longas distâncias de transporte, acesso restrito, terreno difícil, ou condições incomuns do local.",
      ack_price_protection_label: "Preço final pode ser ajustado",
      ack_price_protection_text: "Entendo que o preço final pode ser ajustado se as condições reais do local, especificações do produto, quantidades, acessórios ou requisitos de instalação diferirem das informações fornecidas durante a reserva.",
      price_protection_notice: "O preço final pode ser ajustado se as condições reais do local ou os requisitos de instalação diferirem das informações fornecidas durante a reserva.",
      price_protection_label: "Proteção de Preço:",
      // ── Contato ──
      contact_intro: "Quase pronto. Como podemos te contatar?",
      full_name_required: "Nome completo *",
      phone_required: "Telefone *",
      email_required: "Email *",
      name_ph: "João Silva",
      phone_ph: "(510) 555-1234",
      email_ph: "voce@exemplo.com",
      additional_notes: "Notas adicionais (opcional)",
      additional_notes_ph: "Algo mais que devemos saber?",
      consent_text: "Ao enviar, você concorda em ser contatado sobre seu projeto. Respondemos em até 24 horas.",
      // ── Sucesso ──
      success_desc: "Seu pedido foi salvo para análise. Nossa equipe entrará em contato sobre os próximos passos.",
      confirmation_email_accepted: "Seu email de confirmação foi aceito para envio. A entrega na caixa de entrada ainda não foi confirmada.",
      confirmation_email_unconfirmed: "Não foi possível confirmar o envio do email de confirmação. Seu pedido continua salvo.",
      close: "Fechar",
      success_back_home: "Voltar à página inicial",
      validation_error: "Erro de validação — verifique os dados.",
    },
    footer: {
      tagline: "Recebemos pedidos de orçamento de todos os EUA. Nossa equipe confirma a disponibilidade local.",
      quote_area: "Pedidos de orçamento de todos os EUA",
      contact: "Contato",
      languages: "Idiomas",
      hours: "Seg – Sáb: 8h – 19h",
      rights: "Todos os direitos reservados.",
      keywords: "Instalador de Gazebo · Instalador de Pérgola · Costco Gazebo · Yardistry · Especialista em Estruturas Externas",
    },
  },
  es: {
    nav: {
      services: "Servicios",
      why: "Por Qué Nosotros",
      projects: "Proyectos",
      reviews: "Reseñas",
      contact: "Contacto",
      cta: "Cotización Gratis",
    },
    hero: {
      eyebrow: "Especialistas en Estructuras Exteriores",
      title: "Especialistas en Instalación de Estructuras Exteriores",
      subtitle:
        "Xavier Assembly instala gazebos, pérgolas y estructuras exteriores. Solicita desde cualquiera de los 50 estados: los modelos verificados reciben cotización automática por correo; otros modelos, incluidos PERGOLUX y BON PERGOLA, los revisa nuestro equipo. Nuestro equipo confirma la disponibilidad por ZIP y Xavier confirma la fecha de instalación.",
      cta1: "Cotización Gratis",
      cta2: "Ver Proyectos",
      badges: [
        "Cotización para tu modelo",
        "Disponibilidad confirmada por el equipo",
        "Solicitudes en Todo EE. UU.",
        "Inglés • Portugués • Español",
      ],
    },
    awards: {
      eyebrow: "Reconocidos por la Comunidad",
      title: "Vacaville nos eligió 3 años seguidos",
      subtitle:
        "Orgullosamente reconocidos como Nextdoor Neighborhood Fave en 2023, 2024 y 2025 por profesionalismo, calidad de trabajo y servicio de confianza.",
      yearLabel: "Neighborhood Fave",
      cta: "Gracias a nuestra comunidad por confiar en Xavier Assembly año tras año.",
      placeholder: "Sube la imagen del premio",
    },
    services: {
      eyebrow: "Qué Instalamos",
      quote_coverage: "Solicitudes de Cotización en Todo EE. UU.",
      quote_availability: "Aceptamos solicitudes de cotización de los 50 estados de EE. UU. y Washington, DC. Introduce tu ZIP y confirma el estado; nuestro equipo confirma la disponibilidad de instalación en tu zona.",
      location_pages: "Páginas de Localidades",
      title: "Servicios Premium de Instalación",
      subtitle:
        "Desde gazebos Costco hasta pérgolas Yardistry, manejamos cada estructura con precisión.",
      items: [
        { title: "Instalación de Gazebo", desc: "Gazebos Costco, Yardistry y a medida ensamblados según fábrica." },
        { title: "Instalación de Pérgola", desc: "Pérgolas de madera, aluminio y modernas con láminas." },
        { title: "Ensamble de Cobertizo", desc: "Cobertizos de almacenamiento, jardín y taller nivelados y sellados." },
        { title: "Instalación de Sauna", desc: "Saunas barril y cabina exteriores conectadas y terminadas." },
        { title: "Ensamble de Playground", desc: "Playsets seguros, conformes para patios y comunidades." },
        { title: "Equipos de Gimnasio", desc: "Gimnasios en casa, racks, máquinas y equipos exteriores." },
      ],
    },
    why: {
      eyebrow: "Por Qué Elegirnos",
      title: "Construido Con Oficio. Respaldado Por Confianza.",
      subtitle: "No solo ensamblamos — instalamos con la disciplina de un contratista y el ojo de un artesano.",
      items: [
        { title: "Profesionalismo", desc: "La disponibilidad del equipo, el alcance y la documentación necesaria se revisan para cada trabajo." },
        { title: "Precisión", desc: "Cimientos nivelados con láser y herrajes con torque de fábrica." },
        { title: "Seguridad", desc: "Instalaciones conforme OSHA, estructuras ancladas, playsets en norma." },
        { title: "Acabado Limpio", desc: "Área de montaje ordenada al terminar. La retirada de embalajes, basura y palés se incluye solo cuando está cotizada y acordada." },
        { title: "Comunicación Confiable", desc: "Actualizaciones en tiempo real de cotización a entrega." },
        { title: "Equipo Experimentado", desc: "Revisamos tu modelo, lugar de instalación y alcance solicitado antes de confirmar el trabajo." },
      ],
    },
    projects: {
      eyebrow: "Proyectos Destacados",
      title: "Instalaciones Seleccionadas",
      subtitle: "Un vistazo a gazebos, pérgolas, saunas, gimnasios y playgrounds entregados recientemente.",
    },
    reviews: {
      eyebrow: "Reseñas de Clientes",
      title: "Opiniones de clientes",
      items: [
        { name: "Sarah M.", role: "Walnut Creek, CA", text: "Trabajo excelente ensamblando mi gazebo Costco. Nivelado y sólido." },
        { name: "David R.", role: "Reno, NV", text: "Profesional, puntual y detallista. La mejor experiencia con un contratista." },
        { name: "Marcia L.", role: "San Jose, CA", text: "Altamente recomiendo a Xavier. Pérgola mejor que la foto del showroom." },
        { name: "James K.", role: "Sacramento, CA", text: "Instalaron sauna y gimnasio en dos días. Trabajo impecable." },
        { name: "Patricia O.", role: "Oakland, CA", text: "Gran comunicación de principio a fin. Vale cada dólar." },
        { name: "Carlos T.", role: "Fremont, CA", text: "Atención en español y un playground enorme instalado a la perfección." },
      ],
    },
    googleReviews: {
      eyebrow: "Reseñas de Google",
      empty_heading: "Reseñas de clientes",
      empty_status: "Aún no hay reseñas de clientes publicadas aquí.",
      empty_help: "Para consultar referencias de clientes, utiliza los datos de contacto del pie de página.",
      loading: "Cargando reseñas de clientes…",
      unavailable: "Las reseñas de clientes no están disponibles temporalmente.",
      previous: "Reseña anterior",
      next: "Siguiente reseña",
      go_to_review: "Ir a la reseña",
      heading: "Clientes Reales. Proyectos Reales. Reseñas Reales.",
      read_more: "Ver más reseñas en Google",
      view_on_google: "Ver en Google",
      verified: "Verificado",
    },
    cta: {
      eyebrow: "Cotizaciones Gratis",
      title: "¿Listo para transformar tu espacio exterior?",
      subtitle: "Solicitudes de cotización gratis en todo EE. UU. Nuestro equipo confirma la disponibilidad local y los requisitos del proyecto antes de programar el servicio.",
      call: "Llamar Ahora",
      quote: "Pedir Cotización",
    },
    form: {
      title: "Solicita Tu Cotización Gratis",
      subtitle: "Cuéntanos sobre tu proyecto. Respondemos en 24 horas.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      service: "Servicio requerido",
      location: "Ciudad / Código postal",
      message: "Detalles del proyecto",
      submit: "Enviar Solicitud",
      submitting: "Enviando...",
      success: "Solicitud de presupuesto recibida.",
      error: "Algo salió mal. Llama al (510) 507-9318.",
      services_options: [
        "Instalación de Gazebo",
        "Instalación de Pérgola",
        "Ensamble de Cobertizo",
        "Instalación de Sauna",
        "Ensamble de Playground",
        "Equipos de Gimnasio",
        "Otro",
      ],
      // ── Pasos (8 etapas) ──
      step_label_product: "Producto",
      step_label_configure: "Configurar",
      step_label_site: "Lugar",
      step_label_accessories: "Accesorios",
      step_label_schedule: "Agenda",
      step_label_qualification: "Detalles",
      step_label_agreement: "Términos",
      step_label_contact: "Contacto",
      step_indicator: "Paso {n} / {total}",
      response_promise: "Respondemos en menos de 24 horas",
      done: "Listo",
      back: "Atrás",
      continue: "Continuar",
      submit_request: "Enviar Solicitud",
      // ── Producto ──
      what_installing: "¿Qué vamos a instalar?",
      brand_model: "Marca / modelo",
      brand_model_ph: "ej: Yardistry Meridian",
      structure_brand: "Marca de la estructura (si es diferente)",
      structure_brand_ph: "ej: Sunjoy, Backyard Discovery…",
      purchased_from: "Comprado en",
      purchased_from_ph: "¿Dónde lo compraste?",
      size: "Tamaño",
      size_ph: "Elige el tamaño",
      size_custom_ph: "Escribe el tamaño (ej: 15×22)",
      product_links: "Enlaces del producto (opcional)",
      product_links_ph: "Pega el enlace de Costco, Amazon, Yardistry…",
      link_invalid: "El enlace debe comenzar con http:// o https://",
      photos: "Fotos (opcional)",
      drop_or_click: "Arrastra o haz clic para subir",
      photo_hint: "JPG / PNG / WEBP · 6 por sección · 1MB cada una · 6MB en total entre todas las secciones",
      photo_total_too_large: "Las fotos pueden sumar hasta 6MB entre todas las secciones. Elimina una foto o elige una imagen más pequeña.",
      photo_too_many: "Sube hasta 6 fotos por sección.",
      photo_too_large: "{name} supera 1MB. Elige una imagen más pequeña.",
      photo_invalid: "{name}: usa una imagen JPG, PNG o WEBP.",
      photo_read_error: "No se pudo leer {name}. Prueba otra imagen.",
      // ── Configuración ──
      configure_intro: "Ayúdanos a especificar tu {category} con precisión. Cuanto más sepamos, más exacta será tu cotización.",
      structure_material: "Material de la estructura",
      roof_type: "Tipo de techo",
      shed_material: "Material del cobertizo",
      foundation_type: "Tipo de cimentación",
      platform_option: "Opción de plataforma",
      // ── Lugar ──
      install_location: "Lugar de instalación",
      install_location_ph: "¿Dónde?",
      ground_type: "Tipo de suelo",
      ground_type_ph: "Superficie",
      target_install_date: "Fecha deseada de instalación",
      city_zip: "Ciudad",
      city_zip_ph: "San Jose",
      state_label: "Estado",
      state_placeholder: "Selecciona el estado",
      surface_type: "Tipo de superficie",
      product_delivered_q: "¿Ya fue entregado el producto en el lugar?",
      existing_surface: "Superficie existente en el lugar (opcional)",
      backyard_access: "Acceso al patio",
      assembly_complexity: "Complejidad del ensamble",
      site_work_optional: "Trabajos adicionales en el lugar (opcional)",
      build_platform: "Construir plataforma / cimentación",
      teardown_old: "Desmontar / quitar estructura antigua",
      relocate_existing: "Reubicar gazebo / cobertizo existente",
      electrical_access: "Acceso eléctrico disponible en el lugar",
      backyard_photos: "Fotos del patio (recomendado)",
      backyard_photos_hint: "Las fotos del área de instalación nos ayudan a preparar herramientas, anclaje y personal.",
      inspiration_photos: "Fotos de inspiración / referencia (opcional)",
      inspiration_photos_hint: "Pinterest, Instagram o cualquier referencia del estilo deseado.",
      // ── Accesorios (preguntas obligatorias) ──
      addons_intro: "Por favor responde cada pregunta. Todas las preguntas Sí/No son obligatorias.",
      estimate_label: "Complementos estimados",
      estimate_note: "Instalación base cotizada después de revisión",
      yes: "SÍ",
      no: "NO",
      blinds_q: "¿Tu artículo incluye persianas?",
      blinds_count_q: "¿Cuántas persianas?",
      anchoring_q: "¿Necesitas anclaje?",
      anchoring_count_q: "¿Cuántos anclajes?",
      anchoring_4_label: "4 anclajes",
      anchoring_6_label: "6 anclajes",
      led_q: "¿Tu artículo incluye luces LED?",
      pallet_q: "¿Necesitas retirar paletas?",
      pallet_count_q: "¿Cuántas paletas? ($45 cada una)",
      estimated_cost: "Costo estimado:",
      optional_addons: "Adicionales opcionales de instalación",
      optional_addons_hint: "Selecciona los que apliquen (opcional).",
      addon_cardboard: "Solo Desarmado de Cajas (Quedan en el Lugar)",
      addon_disposal: "Desarmado + Retiro de Cajas",
      optional_addons_bundle_note: "Elige una opción. El servicio de US$120 incluye desarmado y retiro de cajas, sin un cargo adicional de US$45. La opción de US$45 incluye solo el desarmado; las cajas quedan en el lugar.",
      // ── Agenda ──
      schedule_intro: "Elige tu fecha y ventana horaria preferida. La programación final se confirmará en tu cotización escrita.",
      preferred_date: "Fecha preferida de instalación",
      time_window: "Ventana horaria preferida",
      time_morning: "Mañana",
      time_morning_desc: "8 AM – 12 PM",
      time_afternoon: "Tarde",
      time_afternoon_desc: "12 PM – 4 PM",
      time_evening: "Noche",
      time_evening_desc: "4 PM – 7 PM",
      time_flexible: "Flexible",
      time_flexible_desc: "Cualquier hora del día",
      // ── Detalles ──
      qual_intro: "Algunas preguntas rápidas para precalificar tu proyecto.",
      delivery_status: "Estado de entrega de tu producto",
      delivery_delivered: "Entregado",
      delivery_delivered_desc: "Ya está en mi propiedad",
      delivery_scheduled: "Entrega programada",
      delivery_scheduled_desc: "Sé cuándo llega",
      delivery_not_yet: "Aún no entregado",
      delivery_not_yet_desc: "Todavía comprando / enviando",
      estimated_delivery_date: "Fecha estimada de entrega",
      boxes_received: "¿Cuántas cajas / paletas recibiste?",
      boxes_received_ph: "Elige",
      hoa_q: "¿Se requiere aprobación del HOA?",
      hoa_no: "Sin HOA / no requerido",
      hoa_no_desc: "Podemos programar en cualquier momento",
      hoa_yes: "Sí — se requiere aprobación del HOA",
      hoa_yes_desc: "Esperaremos la aprobación",
      hoa_unknown: "No estoy seguro",
      hoa_unknown_desc: "Te orientaremos",
      has_manual: "Tengo el manual de instalación",
      special_instructions: "Instrucciones especiales (opcional)",
      special_instructions_ph: "Código de la reja, perros, plantas frágiles, horario preferido del equipo, etc.",
      // ── Términos ──
      agreement_intro: "Revisa y acepta todas las condiciones del lugar. Cada confirmación es obligatoria para enviar tu reserva.",
      ack_15ft_label: "Cajas del producto a menos de 4.5m (15 ft) del área de instalación",
      ack_15ft_text: "Entiendo que las cajas del producto deben estar a menos de 4.5m (15 pies) del área final de instalación. Si las cajas, paletas o materiales están a más de 4.5m, se podrá aplicar una tarifa adicional de manejo de materiales de $80.",
      ack_clear_access_label: "El camino y el área de instalación estarán despejados",
      ack_clear_access_text: "Confirmo que el camino y el área de instalación estarán despejados y accesibles antes de la llegada del equipo — libres de muebles, almacenamiento, vehículos, materiales de construcción o paisajismo, escombros, o cualquier otro obstáculo.",
      ack_site_prep_label: "Puede aplicar tarifa de preparación del lugar ($80)",
      ack_site_prep_text: "Entiendo que si el equipo debe mover muebles, materiales, cajas, equipos, artículos de paisajismo u otros obstáculos antes del inicio de la instalación, se podrá aplicar una tarifa adicional de preparación del lugar de $80.",
      ack_access_conditions_label: "Condiciones de acceso",
      ack_access_conditions_text: "Entiendo que el precio de instalación asume acceso normal. Pueden aplicar cargos adicionales por escaleras, pendientes pronunciadas, largas distancias de transporte, acceso restringido, terreno difícil, o condiciones inusuales del lugar.",
      ack_price_protection_label: "El precio final puede ajustarse",
      ack_price_protection_text: "Entiendo que el precio final puede ajustarse si las condiciones reales del lugar, especificaciones del producto, cantidades, accesorios o requisitos de instalación difieren de la información proporcionada durante la reserva.",
      price_protection_notice: "El precio final puede ajustarse si las condiciones reales del lugar o los requisitos de instalación difieren de la información proporcionada durante la reserva.",
      price_protection_label: "Protección de Precio:",
      // ── Contacto ──
      contact_intro: "Casi listo. ¿Cómo te contactamos?",
      full_name_required: "Nombre completo *",
      phone_required: "Teléfono *",
      email_required: "Correo electrónico *",
      name_ph: "Juan Pérez",
      phone_ph: "(510) 555-1234",
      email_ph: "tu@ejemplo.com",
      additional_notes: "Notas adicionales (opcional)",
      additional_notes_ph: "¿Algo más que debamos saber?",
      consent_text: "Al enviar, aceptas ser contactado sobre tu proyecto. Respondemos en menos de 24 horas.",
      // ── Éxito ──
      success_desc: "Su solicitud se guardó para revisión. Nuestro equipo le contactará sobre los próximos pasos.",
      confirmation_email_accepted: "Su correo de confirmación fue aceptado para envío. La entrega en su bandeja de entrada aún no se ha confirmado.",
      confirmation_email_unconfirmed: "No se pudo confirmar el envío del correo de confirmación. Su solicitud sigue guardada.",
      close: "Cerrar",
      success_back_home: "Volver al inicio",
      validation_error: "Error de validación — revisa los datos.",
    },
    footer: {
      tagline: "Recibimos solicitudes de cotización de todo EE. UU. Nuestro equipo confirma la disponibilidad local.",
      quote_area: "Solicitudes de cotización de todo EE. UU.",
      contact: "Contacto",
      languages: "Idiomas",
      hours: "Lun – Sáb: 8am – 7pm",
      rights: "Todos los derechos reservados.",
      keywords: "Instalador de Gazebo · Instalador de Pérgola · Costco Gazebo · Yardistry · Especialista en Estructuras Exteriores",
    },
  },
};
